export const health = [
    {
        id: "content-health-trending",
        name: "Trending",
        articles: [
            {
                id: "b5d84dfb-d80f-4ba1-ab4e-c33e255b3157",
                class: "columns-3-balanced",
                header: "Mindfulness",
                url: "#",
                image: {
                    src: "assets/images/benjamin-child-rOn57CBgyMo-unsplash_448.jpg",
                    alt: "Placeholder",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "Photo taken by someone.",
                },
                title: "Consectetur lorem donec massa sapien faucibus et.",
                type: "list",
                content: [
                    {
                        id: "ee44b675-85c6-4aa7-9ce5-5b37311297bb",
                        content: "Eu turpis egestas pretium aenean pharetra. Nisl condimentum id venenatis a condimentum vitae sapien pellentesque habitant.",
                    },
                    {
                        id: "a40135ff-bc16-4a53-b6b1-d25835703af4",
                        content: "Bibendum arcu vitae elementum curabitur vitae nunc sed velit dignissim.",
                    },
                    {
                        id: "d143d9d9-7c3f-4b36-ad47-f591783f1595",
                        content: "Eu non diam phasellus vestibulum lorem. Fermentum dui faucibus in ornare quam viverra orci sagittis.",
                    },
                    {
                        id: "e89bebb4-484b-45f2-a87b-409a941436da",
                        content: "Et malesuada fames ac turpis. Ornare massa eget egestas purus viverra accumsan.",
                    },
                ],
            },
            {
                id: "a1822776-68b2-4d24-95e2-917756de0c12",
                class: "columns-3-balanced",
                header: "Latest research",
                url: "#",
                image: {
                    src: "assets/images/louis-reed-pwcKF7L4-no-unsplash_448.jpg",
                    alt: "Placeholder",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "Photo taken by someone.",
                },
                title: "Sed velit dignissim sodales ut eu sem integer vitae.",
                type: "list",
                content: [
                    {
                        id: "d71c34e3-6c8e-4097-92a4-efd8042a192e",
                        content: "Metus vulputate eu scelerisque felis.",
                    },
                    {
                        id: "e0ab9000-9eea-4f64-b6d2-9f5e1250c0f9",
                        content: "Aliquam sem et tortor consequat id. Feugiat nibh sed pulvinar proin.",
                    },
                    {
                        id: "66f25618-e649-4814-a546-6edcc036dcfe",
                        content: "Quisque non tellus orci ac auctor augue.",
                    },
                    {
                        id: "7b68e99a-151f-4452-99c9-49be9b399c2a",
                        content: "Sed risus pretium quam vulputate dignissim. Vitae tortor condimentum lacinia quis vel eros.",
                    },
                ],
            },
            {
                id: "0a522480-9f37-43e3-bbf2-c5398450a921",
                class: "columns-3-balanced",
                header: "Healthy Senior",
                url: "#",
                image: {
                    src: "assets/images/esther-ann-glpYh1cWf0o-unsplash_448.jpg",
                    alt: "Placeholder",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "Photo taken by someone.",
                },
                title: "Scelerisque in dictum non consectetur a.",
                type: "list",
                content: [
                    {
                        id: "1cb48e86-99fd-44f8-9ce6-016778eb35d2",
                        content: "Odio euismod lacinia at quis risus sed vulputate odio. Ullamcorper eget nulla facilisi etiam.",
                    },
                    {
                        id: "fa57210c-bd31-4f4a-a601-9f3546196b4f",
                        content: "Ipsum consequat nisl vel pretium. Nisi vitae suscipit tellus mauris a diam.",
                    },
                    {
                        id: "e6e75564-56e0-4f87-9169-89f2820f7221",
                        content: "Laoreet id donec ultrices tincidunt arcu non sodales neque sodales.",
                    },
                    {
                        id: "243d7680-08ba-41d8-bff5-b544667064e5",
                        content: "At volutpat diam ut venenatis tellus in metus vulputate eu.",
                    },
                ],
            },
        ],
    },
    {
        id: "content-health-latest-facts",
        name: "Latest Facts",
        articles: [
            {
                id: "db2abfd6-b4d4-4237-850a-7f34de938739",
                class: "columns-3-balanced",
                header: "More Life, But Better",
                image: {
                    src: "assets/images/melissa-askew-8n00CqwnqO8-unsplash_448.jpg",
                    alt: "Placeholder",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "Photo taken by someone.",
                },
                title: "Sed tempus urna et pharetra pharetra massa massa ultricies mi.",
                type: "list",
                content: [
                    {
                        id: "92f15b5f-f191-4636-b197-b65b2fead08f",
                        content: "Pharetra vel turpis nunc eget. Eu feugiat pretium nibh ipsum consequat.",
                    },
                    {
                        id: "fe2aad93-2770-4068-aec3-ed5d630e47ec",
                        content: "Velit dignissim sodales ut eu sem. Viverra accumsan in nisl nisi scelerisque eu ultrices.",
                    },
                    {
                        id: "0f098b80-ec85-4de3-b0d4-4288947febaa",
                        content: "Arcu dictum varius duis at consectetur lorem donec massa sapien.",
                    },
                ],
            },
            {
                id: "8cfeff8c-94cb-4eca-b5e2-b4214b761705",
                class: "columns-3-balanced",
                header: "In case you missed it",
                image: {
                    src: "assets/images/marcelo-leal-6pcGTJDuf6M-unsplash_448.jpg",
                    alt: "Placeholder",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "Photo taken by someone.",
                },
                title: "Egestas pretium aenean pharetra magna ac.",
                type: "text",
                content:
                    "Lectus proin nibh nisl condimentum id venenatis a condimentum vitae. Tincidunt praesent semper feugiat nibh sed pulvinar proin.\n\nQuis ipsum suspendisse ultrices gravida dictum fusce. Id donec ultrices tincidunt arcu non. Pellentesque habitant morbi tristique senectus et netus et malesuada fames.",
            },
            {
                id: "ae3f3c45-b7fe-4729-8374-f3ba8d11eeff",
                class: "columns-3-balanced",
                header: "Space and science",
                image: {
                    src: "assets/images/nasa-cIX5TlQ_FgM-unsplash_448.jpg",
                    alt: "Placeholder",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "Photo taken by someone.",
                },
                title: "Vitae ultricies leo integer malesuada nunc vel risus.",
                type: "list",
                display: "bullets",
                content: [
                    {
                        id: "31fa8504-b3e7-4f33-bce6-d5e63c0e5c36",
                        content: "Semper eget duis at tellus at urna condimentum.",
                        url: "#",
                    },
                    {
                        id: "c86d479a-2603-4b7e-9f8e-c6c2482f1600",
                        content: "Aliquet lectus proin nibh nisl condimentum id. Velit scelerisque in dictum non.",
                        url: "#",
                    },
                    {
                        id: "3793f895-bcf1-4213-91a9-8efb79395dbc",
                        content: "Nulla posuere sollicitudin aliquam ultrices sagittis orci.",
                        url: "#",
                    },
                    {
                        id: "8da08881-849b-4a8c-8890-89c56028c6cd",
                        content: "Condimentum vitae sapien pellentesque habitant. Iaculis at erat pellentesque adipiscing commodo elit at imperdiet.",
                        url: "#",
                    },
                ],
            },
        ],
    },
    {
        id: "content-health-medical-breakthroughs",
        name: "Medical Breakthroughs",
        articles: [
            {
                id: "2afaf4ee-4d1c-4f54-a970-bc8222cc3090",
                class: "columns-3-wide",
                header: "Surgical Inventions",
                url: "#",
                image: {
                    src: "assets/images/national-cancer-institute-A2CK97sS0ns-unsplash_684.jpg",
                    alt: "Placeholder",
                    width: "684",
                    height: "385",
                },
                meta: {
                    captions: "Photo taken by someone.",
                    tag: {
                        type: "breaking",
                        label: "breaking",
                    },
                },
                title: "Nisi est sit amet facilisis magna etiam tempor. Cursus eget nunc scelerisque viverra mauris in aliquam sem fringilla.",
                type: "text",
                content:
                    "Ut eu sem integer vitae justo eget. Ut aliquam purus sit amet luctus. Sit amet mauris commodo quis imperdiet massa tincidunt. Tellus rutrum tellus pellentesque eu tincidunt tortor aliquam nulla facilisi. Turpis nunc eget lorem dolor sed. Ultrices in iaculis nunc sed augue lacus. Quam elementum pulvinar etiam non. Urna cursus eget nunc scelerisque. Nisl purus in mollis nunc sed.",
            },
            {
                id: "7213a42c-c2eb-486a-bb2e-b59f6667fb4a",
                class: "columns-3-narrow",
                header: "Medicare",
                url: "#",
                image: {
                    src: "assets/images/national-cancer-institute-NFvdKIhxYlU-unsplash_336.jpg",
                    alt: "Placeholder",
                    width: "336",
                    height: "189",
                },
                meta: {
                    captions: "Photo taken by someone.",
                },
                title: "Cras semper auctor neque vitae. Vel turpis nunc eget lorem dolor sed viverra ipsum nunc.",
                type: "text",
                content:
                    "Lacus sed viverra tellus in hac habitasse. Sapien faucibus et molestie ac feugiat sed lectus. Pretium aenean pharetra magna ac. Volutpat odio facilisis mauris sit amet massa vitae tortor condimentum. Pellentesque massa placerat duis ultricies lacus sed turpis tincidunt id.\n\nParturient montes nascetur ridiculus mus mauris. Ultrices eros in cursus turpis. Bibendum at varius vel pharetra vel turpis. Luctus venenatis lectus magna fringilla urna porttitor rhoncus dolor.",
            },
            {
                id: "9323f56f-d3b3-4b86-bd4c-014392b62272",
                class: "columns-3-narrow",
                header: "Medication",
                url: "#",
                image: {
                    src: "assets/images/myriam-zilles-KltoLK6Mk-g-unsplash_336.jpg",
                    alt: "Placeholder",
                    width: "336",
                    height: "189",
                },
                meta: {
                    captions: "Photo taken by someone.",
                },
                title: "Ipsum dolor sit amet consectetur adipiscing elit. Velit scelerisque in dictum non consectetur a erat nam.",
                type: "text",
                content:
                    "Mattis molestie a iaculis at erat pellentesque adipiscing. Sed augue lacus viverra vitae congue. Volutpat consequat mauris nunc congue nisi vitae suscipit tellus. Lacus laoreet non curabitur gravida arcu. Nisl nisi scelerisque eu ultrices vitae auctor.\n\nInteger vitae justo eget magna fermentum iaculis eu non. Sollicitudin ac orci phasellus egestas. Ligula ullamcorper malesuada proin libero nunc consequat interdum.",
            },
        ],
    },
    {
        id: "content-health-latest-videos",
        name: "Latest Videos",
        articles: [
            {
                id: "c1f811ca-284b-4e7b-9bfb-bb5a7c72211d",
                class: "columns-1",
                type: "grid",
                content: [
                    {
                        id: "f0e9befa-3d54-4a26-8267-0e38bb0eaa49",
                        image: {
                            src: "assets/images/mufid-majnun-J12RfFH-2ZE-unsplash_684.jpg",
                            alt: "Placeholder",
                            width: "684",
                            height: "385",
                        },
                        meta: {
                            tag: {
                                type: "watch",
                                label: "watch",
                            },
                        },
                    },
                    {
                        id: "e301a866-edd4-47a4-a4a6-ce4035c2ab74",
                        image: {
                            src: "assets/images/irwan-rbDE93-0hHs-unsplash_684.jpg",
                            alt: "Placeholder",
                            width: "684",
                            height: "385",
                        },
                        meta: {
                            tag: {
                                type: "watch",
                                label: "watch",
                            },
                        },
                    },
                    {
                        id: "329f6075-3a95-4a20-b3e1-ade5734544b4",
                        image: {
                            src: "assets/images/hyttalo-souza-a1p0Z7RSkL8-unsplash_684.jpg",
                            alt: "Placeholder",
                            width: "684",
                            height: "385",
                        },
                        meta: {
                            tag: {
                                type: "watch",
                                label: "watch",
                            },
                        },
                    },
                    {
                        id: "50b6d145-34da-4a7a-8f3f-bb1674a7692b",
                        image: {
                            src: "assets/images/jaron-nix-7wWRXewYCH4-unsplash_684.jpg",
                            alt: "Placeholder",
                            width: "684",
                            height: "385",
                        },
                        meta: {
                            tag: {
                                type: "watch",
                                label: "watch",
                            },
                        },
                    },
                ],
            },
        ],
    },
    {
        id: "content-health-educational",
        name: "Educational",
        articles: [
            {
                id: "c2dc8f88-8a0a-4a3f-aadd-a5f83e291081",
                class: "columns-1",
                type: "grid",
                display: "grid-wrap",
                content: [
                    {
                        id: "994fb978-2024-4c58-a1e8-f19e8493c703",
                        image: {
                            src: "assets/images/bruno-nascimento-PHIgYUGQPvU-unsplash_448.jpg",
                            alt: "Placeholder",
                            width: "448",
                            height: "252",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "new",
                            },
                        },
                        text: "Orci phasellus egestas tellus rutrum tellus pellentesque eu. Pulvinar neque laoreet suspendisse interdum consectetur. Viverra maecenas accumsan lacus vel facilisis volutpat. Nibh ipsum consequat nisl vel pretium lectus quam id. Leo integer malesuada nunc vel risus commodo viverra.",
                        url: "#",
                    },
                    {
                        id: "4c2254af-2e9a-4249-a467-112211c41698",
                        image: {
                            src: "assets/images/brooke-lark-lcZ9NxhOSlo-unsplash_448.jpg",
                            alt: "Placeholder",
                            width: "448",
                            height: "252",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "new",
                            },
                        },
                        text: "Proin libero nunc consequat interdum varius sit amet. Convallis posuere morbi leo urna molestie at. Consectetur lorem donec massa sapien faucibus et molestie ac feugiat. Egestas diam in arcu cursus euismod quis viverra nibh.",
                        url: "#",
                    },
                    {
                        id: "a49d65ba-d42c-4b35-8926-479a8988d232",
                        image: {
                            src: "assets/images/kelly-sikkema-WIYtZU3PxsI-unsplash_448.jpg",
                            alt: "Placeholder",
                            width: "448",
                            height: "252",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "new",
                            },
                        },
                        text: "Elit sed vulputate mi sit. Ullamcorper a lacus vestibulum sed arcu non odio euismod lacinia. Magna eget est lorem ipsum dolor sit amet consectetur. In tellus integer feugiat scelerisque varius morbi enim nunc faucibus. Nam libero justo laoreet sit.",
                        url: "#",
                    },
                    {
                        id: "c6f55f29-6b48-433d-85d1-0c952a01fa00",
                        image: {
                            src: "assets/images/robina-weermeijer-Pw9aFhc92P8-unsplash_448.jpg",
                            alt: "Placeholder",
                            width: "448",
                            height: "252",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "new",
                            },
                        },
                        text: "Nam aliquam sem et tortor consequat. Non sodales neque sodales ut etiam sit amet nisl purus. Viverra mauris in aliquam sem. Leo vel fringilla est ullamcorper. Tellus at urna condimentum mattis pellentesque id nibh tortor. Lacus laoreet non curabitur gravida. Ut morbi tincidunt augue interdum velit euismod in pellentesque.",
                        url: "#",
                    },
                    {
                        id: "720a4102-5a8f-4825-ae68-e1d21a69d71a",
                        image: {
                            src: "assets/images/sj-objio-8hHxO3iYuU0-unsplash_448.jpg",
                            alt: "Placeholder",
                            width: "448",
                            height: "252",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "new",
                            },
                        },
                        text: "Egestas integer eget aliquet nibh praesent tristique magna sit. Id consectetur purus ut faucibus. Molestie a iaculis at erat pellentesque adipiscing commodo elit at. Nulla facilisi etiam dignissim diam quis enim lobortis scelerisque. Lectus proin nibh nisl condimentum id. Ornare quam viverra orci sagittis eu volutpat odio facilisis mauris.",
                        url: "#",
                    },
                ],
            },
        ],
    },
    {
        id: "content-health-fitness",
        name: "Fitness",
        articles: [
            {
                id: "4e6716eb-0430-49b0-9d95-352333d760a0",
                class: "columns-wrap",
                header: "Burn your calories",
                type: "excerpt",
                content: [
                    {
                        id: "930209e6-9f95-49c2-b5e7-1b4b8024fc8b",
                        image: {
                            src: "assets/images/scott-webb-U5kQvbQWoG0-unsplash_150.jpg",
                            alt: "Placeholder",
                            width: "150",
                            height: "84",
                        },
                        text: "Dictumst quisque sagittis purus sit amet volutpat consequat. At imperdiet dui accumsan sit amet nulla facilisi. Felis bibendum ut tristique et egestas. Mus mauris vitae ultricies leo integer malesuada. Adipiscing at in tellus integer feugiat.",
                    },
                    {
                        id: "85789d48-e369-43a0-998c-5cc9af9256eb",
                        image: {
                            src: "assets/images/sven-mieke-Lx_GDv7VA9M-unsplash_150.jpg",
                            alt: "Placeholder",
                            width: "150",
                            height: "84",
                        },
                        text: "Morbi non arcu risus quis varius quam quisque id. Enim nulla aliquet porttitor lacus luctus. Quis imperdiet massa tincidunt nunc pulvinar sapien et ligula ullamcorper. Tempor id eu nisl nunc mi ipsum faucibus vitae aliquet. Consequat semper viverra nam libero justo laoreet sit.",
                    },
                    {
                        id: "a8c8607f-8178-4b37-954a-d1578ae6624a",
                        image: {
                            src: "assets/images/geert-pieters-NbpUM86Jo8Y-unsplash_150.jpg",
                            alt: "Placeholder",
                            width: "150",
                            height: "84",
                        },
                        text: "Suscipit adipiscing bibendum est ultricies integer quis auctor elit. Gravida quis blandit turpis cursus in hac habitasse platea. Maecenas ultricies mi eget mauris pharetra et ultrices. Massa sed elementum tempus egestas sed.",
                    },
                ],
            },
            {
                id: "056698a8-0ac8-4342-9e67-25993d574866",
                class: "columns-wrap",
                header: "Gym favorites",
                type: "excerpt",
                content: [
                    {
                        id: "a43f2dd1-ac0d-4ba1-81ef-3fcaf359b5fc",
                        image: {
                            src: "assets/images/boxed-water-is-better-y-TpYAlcBYM-unsplash_150.jpg",
                            alt: "Placeholder",
                            width: "150",
                            height: "84",
                        },
                        text: "Nulla facilisi nullam vehicula ipsum a arcu cursus. Et ultrices neque ornare aenean euismod elementum nisi quis. Velit euismod in pellentesque massa. In fermentum posuere urna nec tincidunt praesent semper.",
                    },
                    {
                        id: "67b4bee9-5248-45b5-98ed-aeadc2a33466",
                        image: {
                            src: "assets/images/jonathan-borba-lrQPTQs7nQQ-unsplash_150.jpg",
                            alt: "Placeholder",
                            width: "150",
                            height: "84",
                        },
                        text: "Sit amet consectetur adipiscing elit duis tristique sollicitudin. Ante metus dictum at tempor commodo ullamcorper. Tincidunt eget nullam non nisi est sit. Platea dictumst quisque sagittis purus sit amet volutpat consequat.",
                    },
                    {
                        id: "e182116f-dff8-4fcf-acb8-b7743e2cbdd2",
                        image: {
                            src: "assets/images/mr-lee-f4RBYsY2hxA-unsplash_150.jpg",
                            alt: "Placeholder",
                            width: "150",
                            height: "84",
                        },
                        text: "Sed vulputate odio ut enim blandit volutpat maecenas. Risus viverra adipiscing at in. Fusce id velit ut tortor pretium viverra. Sem nulla pharetra diam sit amet nisl. Posuere urna nec tincidunt praesent semper feugiat nibh.",
                    },
                ],
            },
            {
                id: "389c5495-b37c-423f-8950-a1845317e41c",
                class: "columns-wrap",
                header: "Pilates",
                type: "excerpt",
                content: [
                    {
                        id: "7bd49e3d-06fc-4195-99bc-3f604de242b3",
                        image: {
                            src: "assets/images/ahmet-kurt-WviyUzOg4RU-unsplash_150.jpg",
                            alt: "Placeholder",
                            width: "150",
                            height: "84",
                        },
                        text: "Massa massa ultricies mi quis hendrerit dolor magna. Cursus vitae congue mauris rhoncus aenean vel elit scelerisque. Vestibulum lorem sed risus ultricies tristique. Egestas fringilla phasellus faucibus scelerisque eleifend donec pretium vulputate.",
                    },
                    {
                        id: "f41e3b74-a33d-4169-b604-099da64e24fb",
                        image: {
                            src: "assets/images/stan-georgiev-pvNxRUq7O7U-unsplash_150.jpg",
                            alt: "Placeholder",
                            width: "150",
                            height: "84",
                        },
                        text: "Massa enim nec dui nunc mattis enim ut tellus elementum. Eros in cursus turpis massa tincidunt dui. Sit amet consectetur adipiscing elit ut aliquam purus sit amet. Eget nullam non nisi est sit amet facilisis magna.",
                    },
                    {
                        id: "5bc866c7-7d7e-44ef-bc98-4c68739be329",
                        image: {
                            src: "assets/images/ahmet-kurt-5BGg2L5nhlU-unsplash_150.jpg",
                            alt: "Placeholder",
                            width: "150",
                            height: "84",
                        },
                        text: "enenatis tellus in metus vulputate eu scelerisque felis imperdiet proin. In eu mi bibendum neque egestas congue quisque egestas. Bibendum est ultricies integer quis auctor elit. Ipsum nunc aliquet bibendum enim facilisis. Magna fringilla urna porttitor rhoncus dolor purus non enim praesent.",
                    },
                ],
            },
        ],
    },
    {
        id: "content-health-guides",
        name: "Guides",
        articles: [
            {
                id: "9a1282a2-e227-4d96-8f3e-99c580f2939a",
                class: "columns-3-balanced",
                header: "Health after 50",
                type: "articles-list",
                content: [
                    {
                        id: "efcabc5f-f52d-47c4-9f94-8bd780882b7a",
                        title: "Ac ut consequat semper viverra nam libero justo.",
                        content:
                            "A lacus vestibulum sed arcu non odio euismod lacinia at. Viverra mauris in aliquam sem fringilla ut morbi tincidunt augue. Enim nec dui nunc mattis enim ut tellus. Congue eu consequat ac felis donec et odio. Vitae sapien pellentesque habitant morbi tristique senectus.",
                    },
                    {
                        id: "2a62c03f-5073-424f-aab5-c0b7e25ae988",
                        title: "Sit amet porttitor eget dolor morbi non arcu risus quis.",
                        content:
                            "Gravida in fermentum et sollicitudin. Diam sollicitudin tempor id eu nisl. Proin libero nunc consequat interdum varius sit amet. Nunc pulvinar sapien et ligula ullamcorper malesuada proin libero. Lacinia quis vel eros donec ac.",
                    },
                    {
                        id: "c8886351-2d3f-422c-a24e-85a3ac682673",
                        title: "Faucibus nisl tincidunt eget nullam non nisi.",
                        content:
                            "Diam ut venenatis tellus in metus. Luctus accumsan tortor posuere ac. Eget aliquet nibh praesent tristique magna. Diam donec adipiscing tristique risus nec feugiat in fermentum posuere. Dolor morbi non arcu risus quis varius quam quisque.",
                    },
                ],
            },
            {
                id: "7b268ec3-8ac2-42fc-ab0f-ac650d2493f1",
                class: "columns-3-balanced",
                header: "Healthy Heart",
                type: "articles-list",
                content: [
                    {
                        id: "ee5dd7b7-30a1-48a9-92c4-9f605ec1d156",
                        title: "Gravida cum sociis natoque penatibus et magnis dis parturient montes.",
                        content:
                            "Nulla porttitor massa id neque aliquam vestibulum morbi. Nullam non nisi est sit amet facilisis. Vitae turpis massa sed elementum tempus. Varius duis at consectetur lorem. Consequat semper viverra nam libero justo laoreet sit.",
                    },
                    {
                        id: "74b09799-d0be-4e52-9bb9-748cde4af833",
                        title: "Non nisi est sit amet facilisis magna etiam tempor orci.",
                        content:
                            "At augue eget arcu dictum varius duis at. Arcu felis bibendum ut tristique et egestas. Elementum tempus egestas sed sed risus pretium quam vulputate. Cursus euismod quis viverra nibh cras pulvinar. Praesent tristique magna sit amet purus gravida quis.",
                    },
                    {
                        id: "9e31db8f-9fba-4a1f-99f8-101e357802b4",
                        title: "Sit amet justo donec enim diam vulputate ut pharetra.",
                        content: "Nulla at volutpat diam ut venenatis tellus. Pulvinar mattis nunc sed blandit libero volutpat. Sit amet justo donec enim diam vulputate. Condimentum id venenatis a condimentum vitae sapien pellentesque habitant.",
                    },
                ],
            },
            {
                id: "f3907983-9885-4211-8878-0f85750bbaa7",
                class: "columns-3-balanced",
                header: "Healthy Digestive",
                type: "articles-list",
                content: [
                    {
                        id: "d70c020f-dec2-4903-bba0-3b20bed16068",
                        title: "Metus aliquam eleifend mi in nulla posuere sollicitudin.",
                        content:
                            "Sodales ut etiam sit amet nisl purus in. Lorem ipsum dolor sit amet consectetur. Tincidunt ornare massa eget egestas purus viverra accumsan in. Orci eu lobortis elementum nibh tellus molestie nunc non. Ut faucibus pulvinar elementum integer enim neque.",
                    },
                    {
                        id: "b80ef050-df82-4ecb-ab98-d5311cae7a2a",
                        title: "Placerat duis ultricies lacus sed. Donec enim diam vulputate ut.",
                        content:
                            "Condimentum id venenatis a condimentum vitae sapien. Eu ultrices vitae auctor eu augue ut lectus. Fermentum iaculis eu non diam phasellus. Urna nunc id cursus metus aliquam eleifend mi. Venenatis cras sed felis eget velit aliquet sagittis.",
                    },
                    {
                        id: "bde5fc93-1779-4cf8-9d54-6ee9abfeb3c4",
                        title: "Rhoncus dolor purus non enim praesent elementum facilisis.",
                        content: "Nunc consequat interdum varius sit. Non diam phasellus vestibulum lorem sed risus ultricies. Feugiat nibh sed pulvinar proin gravida hendrerit lectus a. Eget egestas purus viverra accumsan in nisl nisi scelerisque.",
                    },
                ],
            },
        ],
    },
    {
        id: "content-health-underscored",
        name: "Underscored",
        articles: [
            {
                id: "851b619c-0d4b-478a-8991-d39394660b96",
                class: "columns-2-balanced",
                header: "This First",
                type: "grid",
                content: [
                    {
                        id: "fcf0478b-f9e9-4e2c-abbf-0d02de98e891",
                        image: {
                            src: "assets/images/drew-hays-tGYrlchfObE-unsplash_336.jpg",
                            alt: "Placeholder",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "new",
                            },
                        },
                        text: "Lectus arcu bibendum at varius. Sed id semper risus in hendrerit gravida rutrum. Bibendum ut tristique et egestas quis ipsum suspendisse ultrices gravida. Euismod nisi porta lorem mollis. At varius vel pharetra vel turpis.",
                        url: "#",
                    },
                    {
                        id: "ae54f79f-a7d7-4887-99eb-0e52720a5529",
                        image: {
                            src: "assets/images/hush-naidoo-jade-photography-Zp7ebyti3MU-unsplash_336.jpg",
                            alt: "Placeholder",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "new",
                            },
                        },
                        text: "Pretium aenean pharetra magna ac placerat vestibulum lectus mauris ultrices. Lacus sed turpis tincidunt id. Eget nunc scelerisque viverra mauris in aliquam sem fringilla ut. Dapibus ultrices in iaculis nunc sed.",
                        url: "#",
                    },
                ],
            },
            {
                id: "1080c9e5-4d40-4b28-9398-c03c9f94c74e",
                class: "columns-2-balanced",
                header: "This Second",
                type: "grid",
                content: [
                    {
                        id: "4bfb8bd6-9380-454d-9eae-17b6e6d311c8",
                        image: {
                            src: "assets/images/mathurin-napoly-matnapo-ejWJ3a92FEs-unsplash_336.jpg",
                            alt: "Placeholder",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "breaking",
                                label: "breaking",
                            },
                        },
                        text: "Tempus iaculis urna id volutpat lacus laoreet non. Elementum nisi quis eleifend quam adipiscing vitae proin. Vel pretium lectus quam id leo. Eget sit amet tellus cras adipiscing enim eu turpis.",
                        url: "#",
                    },
                    {
                        id: "53270566-3767-47b9-8a1e-da8ccef49491",
                        image: {
                            src: "assets/images/national-cancer-institute-KrsoedfRAf4-unsplash_336.jpg",
                            alt: "Placeholder",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "breaking",
                                label: "breaking",
                            },
                        },
                        text: "Sapien nec sagittis aliquam malesuada bibendum arcu vitae. Adipiscing vitae proin sagittis nisl rhoncus. Euismod in pellentesque massa placerat duis. Nec tincidunt praesent semper feugiat nibh sed pulvinar proin. Quam nulla porttitor massa id neque.",
                        url: "#",
                    },
                ],
            },
        ],
    },
    {
        id: "content-health-what-to-eat",
        name: "What to eat",
        articles: [
            {
                id: "8ed51654-db6a-4826-bd1c-25213bc4200b",
                class: "columns-wrap",
                header: "Low carbs",
                type: "excerpt",
                content: [
                    {
                        id: "342206b9-9843-477a-b4d0-48cd160b56b2",
                        image: {
                            src: "assets/images/kenny-eliason-5ddH9Y2accI-unsplash_150.jpg",
                            alt: "Placeholder",
                            width: "150",
                            height: "84",
                        },
                        text: "Nec feugiat in fermentum posuere urna. Odio ut sem nulla pharetra. Est ultricies integer quis auctor elit sed. Dignissim cras tincidunt lobortis feugiat vivamus at augue eget.",
                    },
                    {
                        id: "61be9558-b680-4a9c-b9fe-f17a3f58ff53",
                        image: {
                            src: "assets/images/brigitte-tohm-iIupxcq-yH4-unsplash_150.jpg",
                            alt: "Placeholder",
                            width: "150",
                            height: "84",
                        },
                        text: "Egestas sed tempus urna et. Lorem ipsum dolor sit amet consectetur adipiscing elit pellentesque habitant.",
                    },
                    {
                        id: "91414131-2202-462c-84b3-cbf6bf66fb34",
                        image: {
                            src: "assets/images/brooke-lark-oaz0raysASk-unsplash_150.jpg",
                            alt: "Placeholder",
                            width: "150",
                            height: "84",
                        },
                        text: "Sapien pellentesque habitant morbi tristique senectus et netus et malesuada. Dictum non consectetur a erat. Duis ut diam quam nulla porttitor.",
                    },
                ],
            },
            {
                id: "692a6213-1024-4d3e-8e6d-34aed2bb3616",
                class: "columns-wrap",
                header: "Vegetarian",
                type: "excerpt",
                content: [
                    {
                        id: "67db8a8e-9a39-4e2e-ba5a-7d57b0337fb0",
                        image: {
                            src: "assets/images/christina-rumpf-gUU4MF87Ipw-unsplash_150.jpg",
                            alt: "Placeholder",
                            width: "150",
                            height: "84",
                        },
                        text: "Sed viverra tellus in hac habitasse platea dictumst vestibulum. Nisi est sit amet facilisis magna etiam.",
                    },
                    {
                        id: "f045c26c-eaf6-4192-b022-f4c00014caa8",
                        image: {
                            src: "assets/images/nathan-dumlao-bRdRUUtbxO0-unsplash_150.jpg",
                            alt: "Placeholder",
                            width: "150",
                            height: "84",
                        },
                        text: "Convallis a cras semper auctor neque vitae tempus. Cursus risus at ultrices mi tempus imperdiet nulla.",
                    },
                    {
                        id: "02cbeb30-a5f2-4465-9a85-ae00007fd71a",
                        image: {
                            src: "assets/images/maddi-bazzocco-qKbHvzXb85A-unsplash_150.jpg",
                            alt: "Placeholder",
                            width: "150",
                            height: "84",
                        },
                        text: "Ut faucibus pulvinar elementum integer enim neque volutpat. Netus et malesuada fames ac turpis egestas sed tempus urna.",
                    },
                ],
            },
            {
                id: "f264a46c-4e7e-4c9f-bf04-d4ed1fa6639a",
                class: "columns-wrap",
                header: "Breakfast",
                type: "excerpt",
                content: [
                    {
                        id: "719bbe3e-7a4b-4084-9bdd-8597a64d2c1c",
                        image: {
                            src: "assets/images/brooke-lark-IDTEXXXfS44-unsplash_150.jpg",
                            alt: "Placeholder",
                            width: "150",
                            height: "84",
                        },
                        text: "Eget mauris pharetra et ultrices. In ante metus dictum at tempor commodo ullamcorper a. Ut sem nulla pharetra diam sit.",
                    },
                    {
                        id: "05d98dcf-d7e5-4819-b22d-8a289eec2b61",
                        image: {
                            src: "assets/images/joseph-gonzalez-QaGDmf5tMiE-unsplash_150.jpg",
                            alt: "Placeholder",
                            width: "150",
                            height: "84",
                        },
                        text: "Lacus sed turpis tincidunt id aliquet risus. Nulla facilisi etiam dignissim diam quis enim. Non curabitur gravida arcu ac tortor dignissim convallis aenean.",
                    },
                    {
                        id: "55d1073a-c733-4ca4-9ff1-e9ab2266ec84",
                        image: {
                            src: "assets/images/brooke-lark-GJMlSBS0FhU-unsplash_150.jpg",
                            alt: "Placeholder",
                            width: "150",
                            height: "84",
                        },
                        text: "Aliquam etiam erat velit scelerisque in dictum non. Pretium fusce id velit ut tortor pretium viverra.",
                    },
                ],
            },
        ],
    },
    {
        id: "content-health-hot-topics",
        name: "Hot Topics",
        articles: [
            {
                id: "dde55759-06c6-46bc-9f16-bed37ae3d77f",
                class: "columns-2-balanced",
                header: "This First",
                type: "grid",
                content: [
                    {
                        id: "5e8ae348-e705-4be4-8e84-f09c3b2196dc",
                        image: {
                            src: "assets/images/national-cancer-institute-cw2Zn2ZQ9YQ-unsplash_336.jpg",
                            alt: "Placeholder",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "new",
                            },
                        },
                        text: "Augue ut lectus arcu bibendum at varius. Cursus turpis massa tincidunt dui. Feugiat scelerisque varius morbi enim. Vel orci porta non pulvinar. Est velit egestas dui id ornare arcu odio. Amet porttitor eget dolor morbi non arcu risus quis. Turpis in eu mi bibendum neque egestas.",
                        url: "#",
                    },
                    {
                        id: "3ed555d2-4eb9-4263-84f8-8c7f973eae91",
                        image: {
                            src: "assets/images/national-cancer-institute-GcrSgHDrniY-unsplash_336.jpg",
                            alt: "Placeholder",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "new",
                            },
                        },
                        text: "Et pharetra pharetra massa massa. Commodo odio aenean sed adipiscing diam donec adipiscing. In mollis nunc sed id semper risus in hendrerit. A diam sollicitudin tempor id eu nisl nunc. Sit amet consectetur adipiscing elit duis tristique.",
                        url: "#",
                    },
                ],
            },
            {
                id: "17f26d05-24ef-4a12-80b0-611a43449aae",
                class: "columns-2-balanced",
                header: "This Second",
                type: "grid",
                content: [
                    {
                        id: "60c6fd49-f5af-4313-af21-a83cea3ce371",
                        image: {
                            src: "assets/images/national-cancer-institute-SMxzEaidR20-unsplash_336.jpg",
                            alt: "Placeholder",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "breaking",
                                label: "breaking",
                            },
                        },
                        text: "Ac tincidunt vitae semper quis lectus nulla. Porttitor massa id neque aliquam. Sed faucibus turpis in eu mi bibendum neque egestas congue. Tincidunt id aliquet risus feugiat in ante metus. Hendrerit gravida rutrum quisque non tellus orci ac auctor augue. Augue eget arcu dictum varius duis at.",
                        url: "#",
                    },
                    {
                        id: "f4873b14-4600-429e-b239-708aac5872d5",
                        image: {
                            src: "assets/images/national-cancer-institute-L7en7Lb-Ovc-unsplash_336.jpg",
                            alt: "Placeholder",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "breaking",
                                label: "breaking",
                            },
                        },
                        text: "Feugiat pretium nibh ipsum consequat nisl vel pretium lectus quam. Ipsum dolor sit amet consectetur. Non diam phasellus vestibulum lorem sed risus. Porttitor lacus luctus accumsan tortor. Morbi enim nunc faucibus a pellentesque sit amet porttitor. Vel turpis nunc eget lorem. Ligula ullamcorper malesuada proin libero.",
                        url: "#",
                    },
                ],
            },
        ],
    },
    {
        id: "content-health-paid-content",
        name: "Paid Content",
        articles: [
            {
                id: "cbaac182-d046-43ee-b6d7-41a382e959ad",
                class: "columns-4-balanced",
                type: "preview",
                content: [
                    {
                        id: "c195937b-25a2-484b-8b0c-febfbae811b2",
                        image: {
                            src: "assets/images/dom-hill-nimElTcTNyY-unsplash_336.jpg",
                            alt: "Placeholder",
                            width: "336",
                            height: "189",
                        },
                        title: "Eu sem integer vitae justo eget magna fermentum iaculis. Aenean pharetra magna ac placerat vestibulum lectus. Amet commodo nulla facilisi nullam.",
                    },
                ],
            },
            {
                id: "ae883d3e-ef62-4f6e-ac2d-5555ca35f11a",
                class: "columns-4-balanced",
                type: "preview",
                content: [
                    {
                        id: "c5808643-c726-4249-9b1d-270e18dcc84b",
                        image: {
                            src: "assets/images/sarah-dorweiler-gUPiTDBdRe4-unsplash_336.jpg",
                            alt: "Placeholder",
                            width: "336",
                            height: "189",
                        },
                        title: "Nullam vehicula ipsum a arcu cursus vitae congue. Enim ut tellus elementum sagittis vitae et leo duis. Nulla malesuada pellentesque elit eget.",
                    },
                ],
            },
            {
                id: "d8f20994-0098-4367-bc3a-131faa8f768d",
                class: "columns-4-balanced",
                type: "preview",
                content: [
                    {
                        id: "c27fac75-6c7c-4c26-9ac4-4f92c54e7308",
                        image: {
                            src: "assets/images/icons8-team-k5fUTay0ghw-unsplash_336.jpg",
                            alt: "Placeholder",
                            width: "336",
                            height: "189",
                        },
                        title: "Est velit egestas dui id ornare arcu odio. Urna nunc id cursus metus. Pellentesque adipiscing commodo elit at imperdiet dui accumsan sit. At ultrices mi tempus imperdiet nulla malesuada pellentesque elit.",
                    },
                ],
            },
            {
                id: "51f4b351-5916-4422-b661-61b65b911ee5",
                class: "columns-4-balanced",
                type: "preview",
                content: [
                    {
                        id: "05b1ce25-c066-4b9e-8a44-7a25dac28759",
                        image: {
                            src: "assets/images/jessica-weiller-So4eFi-d1nc-unsplash_336.jpg",
                            alt: "Placeholder",
                            width: "336",
                            height: "189",
                        },
                        title: "Erat imperdiet sed euismod nisi porta. Nullam ac tortor vitae purus faucibus ornare. Feugiat nisl pretium fusce id. Massa enim nec dui nunc mattis enim ut tellus elementum.",
                    },
                ],
            },
        ],
    },
];
